export const sambaViewSample = {
    'summary': 'SAMBA > eu-idc > System > euidbmkaf04 > CPU Usage (SUM)',
    'status': 'open',
    'urgency': 'low',
    'event_time': '2020-01-07T16:03:00+09:00',
    'metric_name': 'CPU Usage (SUM)',
    'threshold': '90',
    'metric_value': '93.1',
    'resource_name': 'SAMBA > eu-idc > System > euidbmkaf04',
    'event_type': 'INFO'
};

export const sambaSample = {
    'summary': 'SAMBA > eu-idc > System > euidbmkaf04 > CPU Usage (SUM)',
    'status': 'open',
    'urgency': 'low',
    'event_time': '2020-01-07T16:03:00+09:00',
    'metric_name': 'CPU Usage (SUM)',
    'threshold': '90',
    'metric_value': '93.1',
    'resource_name': 'SAMBA > eu-idc > System > euidbmkaf04',
    'event_type': 'INFO'
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/samba.ts